import { render, staticRenderFns } from "./delivery-plan-add.vue?vue&type=template&id=2bd06be8&scoped=true&"
import script from "./delivery-plan-add.vue?vue&type=script&lang=js&"
export * from "./delivery-plan-add.vue?vue&type=script&lang=js&"
import style0 from "./delivery-plan-add.vue?vue&type=style&index=0&id=2bd06be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd06be8",
  null
  
)

export default component.exports